module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_DoubleRight_16"],"path":[{"$":{"d":"M9.16,8l-6.8,6.24L1,12.76,6.2,8,1,3.24,2.35,1.76ZM8.9,1.76,7.55,3.24,12.75,8l-5.2,4.76L8.9,14.24,15.71,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_DoubleRight_16.svg
// module id = iNBJ
// module chunks = 1